<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="900px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
            <span class="px-3">{{ $t('View Production information') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <table class="section-title-table only-for-print">
            <tr>
              <th class="section-title-content">{{ $t('Production') }}</th>
            </tr>
          </table>

          <v-layout row wrap class="invoice-content">
            <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <table class="info-table" style="width: 100%">
                  <tr>
                    <td colspan="3" class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Staff') }}</div>
                      <strong>
                        <v-chip v-for="(s, index) in productionInfo.staff" :key="index">
                          {{ s }}
                          <span v-if="index !== productionInfo.staff.length - 1" class="only-for-print2"
                            >,&nbsp;&nbsp;</span
                          >
                        </v-chip>
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Factory Name') }}
                      </div>
                      <strong>{{ productionInfo.factory_name || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Product Name') }}
                      </div>
                      <strong>{{ productionInfo.product_name || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">{{ $t('Mixture') }}</div>
                      <strong>{{ productionInfo.mixture_name || '-' }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Used Mixture Quantity') }}
                      </div>
                      <strong>
                        {{ productionInfo.used_mixture_quantity | currency }}
                      </strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Production Quantity') }}
                      </div>
                      <strong>{{ productionInfo.production_quantity | currency }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Estimated Product Quantity') }}
                      </div>
                      <strong>{{ productionInfo.estimated_product_quantity | currency }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Damaged Product Quantity') }}
                      </div>
                      <strong>{{ productionInfo.damaged_product_quantity | currency }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Recycle Raw Material Name') }}
                      </div>
                      <strong>{{ productionInfo.recycle_raw_material_name || '-' }}</strong>
                    </td>

                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Recycle Raw Material Quantity') }}
                      </div>
                      <strong>{{ productionInfo.recycle_raw_material_quantity || '-' }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Shift Time') }}
                      </div>
                      <strong>{{ $t(productionInfo.shift_time) }}</strong>
                    </td>

                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Production Date') }}
                      </div>
                      <strong>{{ productionInfo.production_date }}</strong>
                    </td>
                    <td class="td-padding-bottom" v-if="settings.product_expiry === 'Active'">
                      <div class="caption no-select">
                        {{ $t('Production Expire Date') }}
                      </div>
                      <strong v-if="productionInfo.production_expiration_date">
                        {{ productionInfo.production_expiration_date }}
                      </strong>
                      <strong v-else>-</strong>
                    </td>
                  </tr>
                </table>

                <v-flex xs12 style="margin-top: 40px; margin-bottom:20px">
                  <v-layout row wrap justify-center mb-2>
                    <v-flex xs3 ml-5>
                      <h3 style="text-align: center">
                        {{ $t('Mixture Details') }}
                      </h3>
                    </v-flex>
                    <v-flex xs10 ml-5 mr-5>
                      <v-divider />
                    </v-flex>
                  </v-layout>
                  <table class="printed-table" cellspacing="0">
                    <thead>
                      <tr class="only-for-print">
                        <td>
                          <div class="header-space">&nbsp;</div>
                        </td>
                      </tr>
                      <tr>
                        <th xs1 class="pa-2 view-table-header">#</th>
                        <th class="view-table-header" xs5 pa-2>
                          {{ $t('Raw Material') }}
                        </th>
                        <th class="view-table-header" xs2 pa-2>
                          {{ $t('Quantity') }}
                        </th>
                        <th class="view-table-header" xs2 pa-2>
                          {{ `${$t('Price')} (${systemCurrency})` }}
                        </th>
                        <th class="view-table-header" xs2 pa-2>
                          {{ `${$t('Total')} (${systemCurrency})` }}
                        </th>
                      </tr>
                    </thead>
                    <template v-if="mixtureDetail.length > 0">
                      <tbody>
                        <tr v-for="(row, index) in mixtureDetail" :key="index">
                          <td class="view-table-row">
                            <p class="view-table-content">{{ index + 1 }}</p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ row.raw_material_name }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ row.mixture_quantity | currency }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ row.product_average_price | currency }}
                            </p>
                          </td>
                          <td class="view-table-row">
                            <p class="view-table-content">
                              {{ row.cost | currency }}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4" class="no-select last-table-row">
                            <strong>
                              {{ `${$t('Total Cost')} (${systemCurrency})` }}
                            </strong>
                          </td>
                          <td class="last-table-row2">
                            <strong>
                              {{ productionInfo.all_mixtures_cost | currency }}
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                    <tfoot>
                      <tr class="only-for-print">
                        <td>
                          <div class="footer-space">&nbsp;</div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>

                  <invoice-footer
                    :showSignatureSection="false"
                    :accountantName="''"
                    :payerRecipientName="''"
                    :payerOrRecipient="''"
                    class="only-for-print"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">
            {{ $t('Close') }}
          </v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
// import * as helpers from '@/mixins/helperFunctions.js'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      mixtureDetail: []
    }
  },

  watch: {
    viewDialog: {
      immediate: false,
      handler() {
        if (this.viewDialog) {
          this.mixtureDetail = []
          this.mixtureDetail = this.productionInfo.mixture_detail
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      productionInfo: 'productions/getProductionInfo',
      settings: 'configurations/getSystemSettings'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    printMe() {
      let onlyForPrint = document.querySelectorAll('.only-for-print')
      let onlyForPrint2 = document.querySelectorAll('.only-for-print2')
      let notPrintable = document.querySelectorAll('.not-printable')
      let invoiceContent = document.querySelector('.invoice-content')
      let theDialogContent = document.querySelector('.view-dialog-content')
      let infoTable = document.querySelector('.info-table')
      theDialogContent.classList.remove('grey')
      infoTable.classList.add('add-padding-for-info-table')
      invoiceContent.style.marginTop = '90px'
      notPrintable.forEach(element => {
        element.style.display = 'none'
      })
      onlyForPrint.forEach(element => {
        element.style.display = 'block'
      })
      onlyForPrint2.forEach(element => {
        element.style.display = 'inline'
      })
      document.querySelector('.printed-table').style.marginTop = '-120px'

      this.$htmlToPaper('printArea', () => {
        infoTable.classList.remove('add-padding-for-info-table')
        theDialogContent.classList.add('grey')
        invoiceContent.style.marginTop = '0px'
        onlyForPrint.forEach(element => {
          element.style.display = 'none'
        })
        onlyForPrint2.forEach(element => {
          element.style.display = 'none'
        })
        notPrintable.forEach(element => {
          element.style.display = 'flex'
        })
        document.querySelector('.printed-table').style.marginTop = '0px'
      })
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
.only-for-print2 {
  display: none;
}
</style>
